import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the context
const DesignModeContext = createContext();

// Custom hook to use the context
export const useDesignMode = () => {
  const context = useContext(DesignModeContext);
  if (!context) {
    throw new Error('useDesignMode must be used within a DesignModeProvider');
  }
  return context;
};

// Provider component
export const DesignModeProvider = ({ children }) => {
  // Check localStorage for saved preference, default to design mode (true)
  const [isDesignMode, setIsDesignMode] = useState(() => {
    const saved = localStorage.getItem('designMode');
    return saved !== null ? JSON.parse(saved) : true;
  });

  // Save to localStorage whenever mode changes
  useEffect(() => {
    localStorage.setItem('designMode', JSON.stringify(isDesignMode));
  }, [isDesignMode]);

  const toggleDesignMode = () => {
    // If currently in Design mode, prevent switching to Live mode
    if (isDesignMode) {
      alert('Live Mode is currently disabled. This app is running in Design Mode only.');
      return;
    }
    // Allow switching back to Design mode (though we won't get here since we block Live mode)
    setIsDesignMode(prev => !prev);
  };

  return (
    <DesignModeContext.Provider value={{ isDesignMode, setIsDesignMode, toggleDesignMode }}>
      {children}
    </DesignModeContext.Provider>
  );
};

export default DesignModeContext;

